export function compareBool(a: boolean, b: boolean): number {
  if (a === b) {
    return 0;      
  }
  else if (b) {
    return -1;
  }
  else {
    return 1;
  }
}